import ThirdPartyAdmin from 'components/ThirdPartyAdmin';
import { Field, Formik } from 'formik';
import React, { useState, useEffect } from 'react'
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import ReactSelect from "react-select";
import { Option, LimitedChipsContainer } from 'components/Options';
import * as Yup from "yup";
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useAxios from "hooks/useAxios";
import useContextService from "hooks/useContextService";
import searchicon from "assets/icon/search.svg";
import FormikInputField from 'components/common/Fields/FormikInputField';
import NDCList from 'components/NDCList';
import drugNameHelper from 'pages/PurchaseOrder/components/PurchaseOrderTable/components/drugNameHelper';
import Select from "react-select";
import { update } from 'lodash';
import reseticon from "assets/icon/reset.svg";
import useThirdPartyAdmin from 'hooks/UseThirdPartyAdmin';



let hasDatePopupOpen = false;
let wholesalerData = [];
let filteredAccountNumberData = [];
let accountnumberData = [];
let coveredEntityError = "";
let PharmacyError = "";
let Non340BTenantID = '';
let accounnumbererror = "";
let wholesalerError = "";
let ChainpharmacyError = "";
let thirdPartyAdminErrorError = "";
let coveredEntitiesData = [];
let pharmaciesData = [];
let chainpharmacydata = [];
let isRole = ["GWTPAU"];
let isValid = false;

const SearchContainer = (props) => {
  const API = useAxios();
  const {
    states: { drugcatalog },
    setStates,
    resetStates,
  } = useContextService();
  const { onSearch, onReset, reset, setOptionSelected, setOptSelected, setAccountype, accountType, loading, setLoading } = props;
  const [startDate, setstartDate] = useState(null);
  const { data } = useThirdPartyAdmin();
  const [isTPA, setIsTPA] = useState(false);
  const [endDate, setendDate] = useState(null);
  const [ceDatalist, setCeDatalist] = useState([]);
    const [numberData, setNumberData] = useState([]);
  const [cpDataList, setCpDataList] = useState([]);
  const [hasCESelected, setCESelected] = useState(true);
  const [isSubmited, setIsSubmitted] = useState(false);
  const [SelectedAccountNumber, setAccountNumberSelected] = useState('');
  const [selectedWholesaler, setWholesalerSelected] = useState("");
  const [tpaselect, settpaselect] = useState(false);
  const [selectedNdc, setSelectedNdc] = useState("");
  const [selectedCP, setSelectedCP] = useState([]);
  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });

  const [chainPharmacyList, setChainPharmacyList] = useState();
  const [selectedPhOption, setPhOptionSelected] = useState({
    optionPhSelected: "-1",
  });
  const [wholesalers, setwholesalers] = useState([]);
  const pharmaforce = sessionStorage.getItem("pharmaforce");
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const { roles } = profile || {};
  var isDisable = isRole.includes(roles);

  const {
    thirdPartyAdmin,
    searchTerms,
    coveredEntity,
    wholesaler,
    pharmacy,
    accountcode,
    wholesalerAccountID,
    chainpharmacy,
  } = drugcatalog;

  const {
    thirdPartyAdminID,
    coveredEntityIDs,
    pharmacyIDs,
    wholesalerID,
    chainpharmacyID,
    WholesalerAccountID
  } = searchTerms;
  const { tenantID } = thirdPartyAdmin;

  useEffect(() => {
    setCESelected(true);
    setPhOptionSelected({ optionPhSelected: "-1" });
    setAccountNumberSelected("");
    setSelectedNdc("");
    setAccountype(1);
    thirdPartyAdminErrorError = [];
    coveredEntityError = [];
    wholesalerError = [];
    PharmacyError = [];
    accounnumbererror = [];
     setNumberData([])
    ChainpharmacyError = [];
    resetStates("drugCatalog");
  }, [reset]);

  const updateStates = (drugCatalog) => {
    setStates("drugCatalog", drugCatalog);
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const accountypevalues = isDisable == false ? [
    { id: 1, label: "340B" },
    { id: 2, label: "Non-340B" },

  ] : [
    { id: 1, label: "340B" },
  ]

  useEffect(() => {
    setOptionSelected({ optionSelected: "-1" });
    drugcatalog.coveredEntity = "";
    drugcatalog.searchTerms.coveredEntityID = "";
    drugcatalog.pharmacy = "";
    drugcatalog.searchTerms.pharmacyID = "";
    drugcatalog.thirdPartyAdmin = {};
    drugcatalog.searchTerms.thirdPartyAdminID = "";
    drugcatalog.searchTerms.chainpharmacy = "";
    drugcatalog.searchTerms.chainpharmaciesID = "";
    drugcatalog.coveredEntity = "";
    drugcatalog.searchTerms.coveredEntityID = "";
    setCEOptionSelected({
      optionCESelected: "-1",
    });
    drugcatalog.pharmacies = "";
    drugcatalog.searchTerms.pharmacyIDs = "";
    setPhOptionSelected({
      optionPhSelected: "-1",
    });
    drugcatalog.searchTerms.ceIds = {};
    setSelectedNdc("");
    drugcatalog.searchTerms.ndc = {};
    drugcatalog.wholesaler = "";
    drugcatalog.searchTerms.wholesalerID = "";
    updateStates(drugcatalog);
    coveredEntitiesData = [];
    pharmaciesData = [];
    wholesalerData = [];
    setCeDatalist([]);
    setwholesalers([]);
    setCpDataList([]);
    setSelectedCP([]);
    setAccountNumberSelected([]);
    // setAccountNumberSelected("");
    updateStates(drugcatalog);
    setOptSelected({ optSelected: "-1" });
    setPhOptionSelected({ optionPhSelected: "-1" });
    resetStates("drugcatalog");
  }, [])

  useEffect(() => {
    fetchChainPharmacies();
    setOptionSelected({ optionSelected: "-1" });
    drugcatalog.coveredEntity = "";
    drugcatalog.searchTerms.coveredEntityID = "";
    drugcatalog.pharmacy = "";
    drugcatalog.searchTerms.pharmacyID = "";
    drugcatalog.thirdPartyAdmin = {};
    drugcatalog.searchTerms.thirdPartyAdminID = "";
    drugcatalog.searchTerms.chainpharmacy = "";
    drugcatalog.searchTerms.chainpharmaciesID = "";
    drugcatalog.coveredEntity = "";
    drugcatalog.searchTerms.coveredEntityID = "";
    setCEOptionSelected({
      optionCESelected: "-1",
    });
    drugcatalog.pharmacies = "";
    drugcatalog.searchTerms.pharmacyIDs = "";
    setPhOptionSelected({
      optionPhSelected: "-1",
    });
    drugcatalog.searchTerms.ceIds = {};
    setSelectedNdc("");
    drugcatalog.searchTerms.ndc = {};
    drugcatalog.wholesaler = "";
    drugcatalog.searchTerms.wholesalerID = "";
    drugcatalog.accountnumberData = "";
    updateStates(drugcatalog);
    coveredEntitiesData = [];
    pharmaciesData = [];
    wholesalerData = [];
    setNumberData([])
    setCeDatalist([]);
    setwholesalers([]);
    setCpDataList([]);
    setSelectedCP([]);
    setAccountNumberSelected([]);
    // setAccountNumberSelected("");
    updateStates(drugcatalog);
    setOptSelected({ optSelected: "-1" });
    setPhOptionSelected({ optionPhSelected: "-1" });
    resetStates("drugcatalog");

  }, [accountType])

  const findCP = async (value) => {
    setChainPharmacyList(value);
  };


  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    coveredEntitiesData = [];

    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );

      if (data) {
        if (coveredEntitiesData.length == 0) {
          for (var x in data) {
            coveredEntitiesData.push({ value: data[x].id, label: data[x].description });
          }
          setCeDatalist(coveredEntitiesData);
        }
      }
    } catch (error) {
      console.log(error.message);
    }


    // if (coveredEntitiesData.length == 1) {
    //   var ceData = [];
    //   ceData.push(coveredEntitiesData[0]);
    //   drugcatalog.searchTerms.coveredEntityIDs = ceData;
    //   window.selectedCoveredEntittyId = ceData;
    // }

    if (drugcatalog.searchTerms.coveredEntityIDs) {
      var ceSelected = {};
      ceSelected.optionCESelected = [];
      for (var x in drugcatalog.searchTerms.coveredEntityIDs) {
        ceSelected.optionCESelected.push(
          drugcatalog.searchTerms.coveredEntityIDs[x]
        );
      }
      setCEOptionSelected(ceSelected);
      // let ceIds = drugcatalog.searchTerms.coveredEntityIDs.map(
      //   (item) => item["value"]
      // );

    }
    updateStates(drugcatalog);
  };




  const fetchPharmacyName = async (coveredEntityIDs) => {
    pharmaciesData = []
    if (accountType == 1) {
      if (coveredEntityIDs !== undefined) {
        try {
          pharmaciesData = [];
          const payload = {};
          payload.CoveredIDS = [coveredEntityIDs];

          const { data } = await API.post(
            `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
            payload,
            {
              hasDefaultURL: true,
              hideLoader: true,
            }
          );
          if (data) {
            for (var x in data) {
              if (!pharmaciesData.some(item => item.value === data[x].pharmacyID)) {
                pharmaciesData.push({
                  value: data[x].pharmacyID,
                  label: data[x].pharmacyName,
                });
              }
            }
            drugcatalog.pharmacies = data;

            updateStates(drugcatalog);

          }
        } catch (error) {
          (error.message);
        }
      }
    }
  };

  const fetchPharmaciesbychainpharmacy = async (selectedCP) => {
    pharmaciesData = []
    try {
      const { data } = await API.get(
        `GWConfig/Pharmacy/PHList/${selectedCP.value}/${selectedCP.associateTypeID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          pharmaciesData.push({
            value: data[x].pharmacyID,
            label: data[x].pharmacyName,
          });
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchWholesalers = async (ceids, selected) => {
    let ceId = ceids.value;
    let pHID = selected.value;
    try {
      const { data } = await API.get(`GWConfig/Wholesaler/wholesalerslist/${ceId}/${pHID}`, {
        hasDefaultURL: true,
        hideLoader: true,
      });
      if (data) {
        if (wholesalerData.length == 0) {
          for (var x in data) {
            wholesalerData.push({ "id": data[x].wholesalerID, "description": data[x].wholeSalerName });
          }
          setwholesalers(wholesalerData);
        }
      } else {
        setwholesalers([]);
      }
    } catch (error) { }

  };


  const fetchChainPharmacies = async () => {
    setCpDataList([]);
    let CPData = [];
    try {
      const { data } = await API.get(
        `GWConfig/Pharmacy/CPList`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        CPData= [];
        Non340BTenantID = data[0].tenantID
        for (var x in data) {
          CPData.push({ value: data[x].chainPharmacyID, label: data[x].chainPharmacyName, Non340BTenantID: data[x].tenantID , associateTypeID : data[x].associateTypeID  });
        }
        setCpDataList(CPData);
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  const fetchAccountNumber = async (value) => {
    accountnumberData = []
    try {
      setNumberData([])
      filteredAccountNumberData = [];
      const payload = {};
      payload.CoveredEntityIDs = [coveredEntityIDs.value]
      payload.ChainPharmacyIDs = [selectedCP.value]
      payload.PharmacyIDs = [pharmacyIDs.value];
      payload.WholesalerId = parseInt(value);
      const { data } = await API.post(
        `GWConfig/Wholesaler/accountnumbers`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true
        }
      );
      if (data) {
        for (var x in data) {
          accountnumberData.push({ id: data[x].wholesalerAccountCode, description: data[x].wholesalerAccountCode })
        }

        setNumberData(accountnumberData);


      } else {
        //filteredAccountNumberData = [];
      }
    } catch (error) {


    }
    //  }
  };
  const fetchAccountNumberbywholesaler = async (value) => {
     accountnumberData = []
    try {
      setNumberData([])
      const payload = {};
      payload.ChainPharmacyIDs = [selectedCP.value]
      payload.PharmacyIDs = [pharmacyIDs.value];
      payload.WholesalerId = parseInt(value);
      const { data } = await API.post(
        `GWConfig/Pharmacy/accountnumbers`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,

        }
      );
      if (data) {
        for (var x in data) {
          accountnumberData.push({ id: data[x].wholesalerAccountCode, description: data[x].wholesalerAccountCode })
        }
       setNumberData(accountnumberData);

      } else {
      }
    } catch (error) {
      console.log(error);
    }

  };
  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    thirdPartyAdminErrorError = "";
    isValid = false
     drugcatalog.coveredEntity = "";
      drugcatalog.searchTerms.coveredEntityIDs = "";
      setCEOptionSelected({
        optionCESelected: "-1",
      });
      setCeDatalist([]);
      coveredEntitiesData = [];
      //ceData = [];
      pharmaciesData = [];
      drugcatalog.searchTerms.pharmacy = "";
      drugcatalog.searchTerms.pharmacyID = "";
      setPhOptionSelected({
        optionPhSelected: "-1",
      });
      drugcatalog.wholesalers = "";
      wholesalerData = [];
      drugcatalog.searchTerms.wholesalerID = "";
    if (tpa) {
	  coveredEntitiesData = [];
      drugcatalog.coveredEntity = "";
      drugcatalog.searchTerms.coveredEntityIDs = "";
      // const { thirdPartyAdminID } = tpa;
      const { thirdPartyAdminID } = tpa;
      fetchCoveredEntities(thirdPartyAdminID);
      drugcatalog.thirdPartyAdmin = tpa;
      drugcatalog.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
      drugcatalog.searchTerms.accountcode = "";
      setNumberData([])
      setAccountNumberSelected([]);
      settpaselect(true)

    } else {
      setOptionSelected({ optionSelected: "-1" });
      coveredEntitiesData = []
      setCEOptionSelected({ optionCESelected: "-1" });
      drugcatalog.coveredEntity = "";
      drugcatalog.searchTerms.coveredEntityID = "";
      drugcatalog.pharmacy = "";
      drugcatalog.searchTerms.pharmacyID = "";
      drugcatalog.thirdPartyAdmin = "";
      drugcatalog.searchTerms.thirdPartyAdminID = "";
      drugcatalog.searchTerms.chainpharmacy = "";
      drugcatalog.searchTerms.chainpharmaciesID = "";
      setCEOptionSelected({
        optionCESelected: "-1",
      });
      drugcatalog.pharmacies = "";
      drugcatalog.searchTerms.pharmacyIDs = "";
      setPhOptionSelected({
        optionPhSelected: "-1",
      });
      drugcatalog.searchTerms.ceIds = {};
      drugcatalog.wholesaler = "";
      drugcatalog.searchTerms.wholesalerID = "";
      drugcatalog.searchTerms.accountcode = "";
      setCeDatalist([]);
      setwholesalers([]);
      pharmaciesData = []
      setCpDataList([]);
      setAccountype(1)
      setSelectedCP([]);
      thirdPartyAdminErrorError = [];
      coveredEntityError = [];
      wholesalerError = [];
      PharmacyError = [];
      accounnumbererror = [];
      setNumberData([])
      ChainpharmacyError = [];
      setAccountNumberSelected("");
      setOptSelected({ optSelected: "-1" });
      setPhOptionSelected({ optionPhSelected: "-1" });
      resetStates("drugcatalog");
      setSelectedNdc("");
      drugcatalog.searchTerms.ndc = {};
      drugcatalog.wholesalers = "";
      wholesalerData = []
      drugcatalog.searchTerms.wholesalerID = ""
      updateStates(drugcatalog)
    }
    updateStates(drugcatalog);
  };
  console.log(selectedCEOption, "selectedCEOption")

  const handleCEChange = (selected) => {
    coveredEntityError = "";
    isValid = false
    if (selected != null) {
      drugcatalog.searchTerms.coveredEntityIDs = selected;
      setCEOptionSelected({
        optionCESelected: selected,
      });
      drugcatalog.pharmacies = "";
      pharmaciesData = []
      drugcatalog.searchTerms.pharmacyIDs = "";
      setPhOptionSelected({
        optionPhSelected: "-1",
      })

      drugcatalog.wholesalers = "";
      wholesalerData = []
      drugcatalog.searchTerms.wholesalerID = "";
      drugcatalog.accountnumberData = "";
      setNumberData([])
      fetchPharmacyName(selected.value);

    } else {
      drugcatalog.coveredEntity = "";
      drugcatalog.searchTerms.coveredEntityIDs = "";
      setCEOptionSelected({
        optionCESelected: "-1",
      })

      drugcatalog.wholesalers = "";
      wholesalerData = []
      drugcatalog.searchTerms.wholesalerID = "";
      drugcatalog.accountnumberData = "";
      setNumberData([])
      drugcatalog.pharmacies = "";
      pharmaciesData = []
      drugcatalog.searchTerms.pharmacyIDs = "";
      setPhOptionSelected({
        optionPhSelected: "-1",
      })


    }
     setNumberData([])
    updateStates(drugcatalog);
    setAccountNumberSelected("");


  };
  const handlepharmacyChange = (selected, setFieldValue) => {
    PharmacyError = "";
    isValid = false
    if (selected != null) {
      drugcatalog.searchTerms.pharmacyIDs = selected;
      drugcatalog.searchTerms.Non340BTenantID = selected.Non340BTenantID;
      wholesalerData = []
      drugcatalog.wholesalers = "";
      drugcatalog.searchTerms.wholesalerID = "";
      drugcatalog.accountnumberData = "";
      setNumberData([])

      setPhOptionSelected({
        optionPhSelected: selected,
      });
      if (accountType == 1) {
        fetchWholesalers(drugcatalog.searchTerms.coveredEntityIDs, selected);
      }
      else {
        fetchWholesalersBasedOnCP(selected);
      }
    }
    else {
      drugcatalog.pharmacies = "";
      drugcatalog.searchTerms.pharmacyIDs = "";
      setPhOptionSelected({
        optionPhSelected: "-1",
      });
      drugcatalog.wholesalers = "";
      wholesalerData = [];
      drugcatalog.searchTerms.wholesalerID = "";

    }
    drugcatalog.searchTerms.accountnumberData = "";
      setNumberData([])
    setAccountNumberSelected("")
    updateStates(drugcatalog);
    
  };

  const fetchWholesalersBasedOnCP = async (selected) => {
    wholesalerData = []
    let ceId = selectedCP.value;
    let pHID = selected.value

    try {
      const { data } = await API.get(`GWConfig/Pharmacy/CPWholesalerList/${ceId}/${pHID}`, {
        hasDefaultURL: true,
        hideLoader: true,
      });
      if (data) {
        if (wholesalerData.length == 0) {

          for (var x in data) {
            wholesalerData.push({ "id": data[x].wholesalerID, "description": data[x].wholeSalerName });
          }
        }
        setwholesalers(wholesalerData);
      } else {
        setwholesalers([]);
      }
    } catch (error) { }
  };



  const handleSubmit = async () => {
    let values = {};
    values.thirdPartyAdminID = thirdPartyAdmin.thirdPartyAdminID;
    values.chainPharmacyID = selectedCP.value;
    values.coveredEntityIDs = coveredEntityIDs ? coveredEntityIDs.value : [];
    values.pharmacyIDs = pharmacyIDs ? pharmacyIDs : [];
    values.wholesalerID = wholesalerID;
    values.accountcode = SelectedAccountNumber;

    if (selectedNdc.id > 0) {
      values.ndc = selectedNdc.id;
    }
    if (accountType == 2) {
      values.Non340BTenantID = Non340BTenantID;
    }

    if (accountType == 1 && values.thirdPartyAdminID == undefined) {
      thirdPartyAdminErrorError = " Third Party Administrator is Required"
      isValid = true;

    }
    if (accountType == 1 && (values.coveredEntityIDs == undefined || values.coveredEntityIDs.length == 0)) {
      coveredEntityError = "Covered Entity is Required"
      isValid = true;
    }
    if (values.pharmacyIDs == undefined || values.pharmacyIDs == "") {
      PharmacyError = "Pharmacy is Required"
      isValid = true;
    }
    if (values.wholesalerID == undefined || values.wholesalerID == "") {
      wholesalerError = "Wholesaler is Required";
      isValid = true;
    }
    if (values.accountcode == undefined || values.accountcode === "" || values.accountcode.length == 0) {
      accounnumbererror = "Account Number is Required"
      isValid = true;
    }
    if (accountType == 2 && values.chainPharmacyID == undefined || values.chainPharmacyID == "") {
      ChainpharmacyError = "Chain Pharmacy is Required"
      isValid = true;
    }


    if (!isValid) {
      await onSearch(values);
    }


    return;
    // setSubmitting(false);
  };


  const handleReset = async () => {
    if (accountType == "2") {
      fetchChainPharmacies();
    }
    setOptionSelected({ optionSelected: "-1" });
    coveredEntitiesData = []
    setCEOptionSelected({ optionCESelected: "-1" });
    drugcatalog.coveredEntity = "";
    drugcatalog.searchTerms.coveredEntityID = "";
    drugcatalog.pharmacy = "";
    drugcatalog.searchTerms.pharmacyID = "";
    drugcatalog.thirdPartyAdmin = "";
    drugcatalog.searchTerms.thirdPartyAdminID = "";
    drugcatalog.searchTerms.chainpharmacy = "";
    drugcatalog.searchTerms.chainpharmaciesID = "";
    setCEOptionSelected({
      optionCESelected: "-1",
    });
    drugcatalog.pharmacies = "";
    drugcatalog.searchTerms.pharmacyIDs = "";
    setPhOptionSelected({
      optionPhSelected: "-1",
    });
    drugcatalog.searchTerms.ceIds = {};
    drugcatalog.wholesalers = "";
    wholesalerData = []
    drugcatalog.searchTerms.wholesalerID = "";
    drugcatalog.searchTerms.accountcode = "";
    setCeDatalist([]);
    setwholesalers([]);
    pharmaciesData = []
    setCpDataList([]);
    setSelectedCP([]);
    thirdPartyAdminErrorError = [];
    coveredEntityError = [];
    wholesalerError = [];
    PharmacyError = [];
    accounnumbererror = [];
      setNumberData([])
    ChainpharmacyError = [];
    setAccountNumberSelected("");
    setOptSelected({ optSelected: "-1" });
    setPhOptionSelected({ optionPhSelected: "-1" });
    resetStates("drugcatalog");
    setSelectedNdc("");
    drugcatalog.searchTerms.ndc = {};
    updateStates(drugcatalog)
    await onReset();

  };

  const handleNdc = (ndc, setfieldvalue) => {
    if (ndc) {
      setSelectedNdc(ndc);
      // setfieldvalue("ndc", ndc.id);
      drugcatalog.searchTerms.ndc = ndc;
      updateStates(drugcatalog);
    } else {
      drugcatalog.searchTerms.ndc = '';
      updateStates(drugcatalog);
      setSelectedNdc("");
    }
  };

  const handelAccountype = (e, value) => {
    if (e.target.value == 2) {
      fetchChainPharmacies();
      drugcatalog.coveredEntity = "";
      drugcatalog.searchTerms.coveredEntityID = "";
      drugcatalog.pharmacy = "";
      drugcatalog.searchTerms.pharmacyID = "";
      drugcatalog.thirdPartyAdmin = {};
      drugcatalog.searchTerms.thirdPartyAdminID = "";
      drugcatalog.searchTerms.chainpharmacy = "";
      drugcatalog.searchTerms.chainpharmaciesID = "";
      drugcatalog.searchTerms.wholesalerAccountID = "";
      drugcatalog.searchTerms.accountnumberData = "";
      drugcatalog.searchTerms.pharmaciesData = "";
      drugcatalog.searchTerms.wholesalerData = "";

    }
    setAccountype(e.target.value)
    setAccountNumberSelected("");
    accounnumbererror = "";
    ChainpharmacyError = '';
    coveredEntityError = "";
    PharmacyError = "";
    wholesalerError = "";
    thirdPartyAdminErrorError = "";
    onReset();


  }
  const handleWhChange = ({ target: { value } }, setFieldValue) => {
    setAccountNumberSelected("");
    wholesalerError = "";
    isValid = false
    drugcatalog.searchTerms.wholesalerID = value;
    if (value != "") {
      if (accountType == 1) {
        fetchAccountNumber(value);
      }
      else if (accountType == 2) {
        fetchAccountNumberbywholesaler(value);
      }
    }else{
       setAccountNumberSelected("");
       drugcatalog.accountnumberData = "";
    }
      setNumberData([])
    updateStates(drugcatalog);
  };
  const handleAccountNumberChange = (e, setFieldValue) => {
    accounnumbererror = "";
    isValid = false
    const { value } = e.target;
    const findObj = find(filteredAccountNumberData, {
      wholesalerAccountID: parseInt(value),
    });
    // setFieldValue(WholesalerAccountID, value);
    drugcatalog.accountType = findObj;
    drugcatalog.searchTerms.WholesalerAccountID = value;
    drugcatalog.searchTerms.WholesalerAccount = findObj;
    // setFieldValue("WholesalerAccount", findObj);
    setAccountNumberSelected(value);
    updateStates(drugcatalog);
  };
  const handleChainpharmacyChange = (selected, setfieldvalue) => {
    ChainpharmacyError = "";
    isValid = false
    let selectedcpvalue = []
    selectedcpvalue.push(selected)
    if (selected != null) {
      setSelectedCP(selectedcpvalue[0]);
      wholesalerData = []
      drugcatalog.wholesalers = "";
      drugcatalog.searchTerms.wholesalerID = "";
      pharmaciesData = []
      drugcatalog.pharmacies = "";
      drugcatalog.searchTerms.pharmacyIDs = "";
      drugcatalog.searchTerms.associateTypeID = selected.associateTypeID ;
      setPhOptionSelected({
        optionPhSelected: "-1",
      });
      drugcatalog.searchTerms.accountnumberData = "";
      drugcatalog.searchTerms.chainpharmacyID=[selected];

      setNumberData([])
      setAccountNumberSelected('')
      fetchPharmaciesbychainpharmacy(selected);
    }
    else {
      setSelectedCP([]);
      wholesalerData = []
      drugcatalog.wholesalers = "";
      drugcatalog.searchTerms.wholesalerID = "";
      pharmaciesData = []
      drugcatalog.pharmacies = "";
      drugcatalog.searchTerms.pharmacyIDs = "";
      setPhOptionSelected({
        optionPhSelected: "-1",
      });
      drugcatalog.searchTerms.accountnumberData = "";
      //accountnumberData = [];
      setNumberData([])
      setAccountNumberSelected('')
      thirdPartyAdminErrorError = [];
      coveredEntityError = [];
      wholesalerError = [];
      PharmacyError = [];
      accounnumbererror = [];
      setNumberData([])
      ChainpharmacyError = [];
      drugcatalog.searchTerms.associateTypeID = [] ;
    }


  };

  return (
    <div>
      <Formik
        onSubmit={handleSubmit}
        initialValues={""}
        enableReinitialize={true}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div>
              <h5 className="f-16 text-primary font-weight-700">
                Search Drug Catalog
              </h5>
              <Row>
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="claimtype">Account Type</Label>
                    <Input
                      id="accountype"
                      name="accountype"
                      type="select"
                      value={accountType}
                      onChange={(e) => handelAccountype(e, setFieldValue)}
                      className='required'
                    >
                      {accountypevalues.map((status) => {
                        const { id, label } = status;
                        return (
                          <option key={id} value={id}>
                            {label}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                {accountType == 1 &&
                  <Col md={3} sm={3} xs={3}>
                    <FormGroup>
                      <Label for="tpa">Third Party Administrator</Label>
                      <ThirdPartyAdmin
                        value={thirdPartyAdminID}
                        name="thirdPartyAdminID"
                        onChange={(value, tpa) =>
                          handleThirdPartyAdminChange(value, setFieldValue, tpa)
                        }
                      />
                      {
                        thirdPartyAdminErrorError.length > 0
                          ? (
                            <div className="text-danger f-12 position-absolute">
                              {thirdPartyAdminErrorError}
                            </div>
                          ) : null}
                    </FormGroup>
                  </Col>
                }
                {accountType == 1 &&
                  <Col md={3} sm={3} xs={3}>
                    <FormGroup>
                      <Label for="ceDatalist">Covered Entity</Label>
                      <ReactSelect
                        name="coveredEntityIDs"
                        id="coveredEntityIDs"
                        options={coveredEntitiesData}
                        isMulti={false}
                        className='required drug_ce'
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        isClearable={true}
                        components={{
                          Option,
                          //ValueContainer: LimitedChipsContainer,
                        }}
                        value={selectedCEOption.optionCESelected}
                        isSearchable="true"
                        onChange={
                          handleCEChange
                        }
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: 'flex',
                            alignItems: 'flex',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            alignItems: "start",
                            backgroundColor: 'transparent'
                          })
                        }}
                      />
                      {
                        coveredEntityError.length > 0
                          ? (
                            <div className="text-danger f-12 position-absolute">
                              {coveredEntityError}
                            </div>
                          ) : null}
                    </FormGroup>
                  </Col>
                }
                {accountType == 2 &&
                  <Col md={3} sm={3} xs={3}>
                    <FormGroup>
                      <Label for="ceDatalist">Chain Pharmacy</Label>
                      <ReactSelect
                        name="chainpharmacyID"
                        id="chainpharmacyID"
                        options={cpDataList}
                        className='required'
                        isMulti={false}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        isClearable={true}
                        components={{
                          Option,
                          //ValueContainer: LimitedChipsContainer,
                        }}
                        value={selectedCP}
                        isSearchable="true"
                        onChange={(value) => { handleChainpharmacyChange(value, setFieldValue) }}
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: 'flex',
                            alignItems: 'flex',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            alignItems: "start",
                            backgroundColor: 'transparent'
                          })
                        }}
                      />
                      {
                        ChainpharmacyError.length > 0
                          ? (
                            <div className="text-danger f-12 position-absolute">
                              {ChainpharmacyError}
                            </div>
                          ) : null}
                    </FormGroup>
                  </Col>
                }
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="pharmacyname">Pharmacy</Label>
                    <ReactSelect
                      name="pharmacydatalist"
                      id="pharmacydatalist"
                      options={pharmaciesData}
                      className='required'
                      component={FormikSelectField}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      optionSelected={true}
                      isClearable={true}
                      isMulti={false}
                      components={{
                        Option,
                        // ValueContainer: LimitedChipsContainer,

                      }}
                      isSearchable="true"
                      onChange={(value, entity) =>
                        handlepharmacyChange(value, setFieldValue, entity)
                      }
                      value={selectedPhOption.optionPhSelected}
                      defaultoption="--Select--"
                      maxMenuHeight={220}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        option: (provided) => ({
                          ...provided,
                          display: 'flex',
                          alignItems: 'flex',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          alignItems: "start",
                          backgroundColor: 'transparent'
                        })
                      }}
                    />
                    {
                      PharmacyError.length > 0
                        ? (
                          <div className="text-danger f-12 position-absolute">
                            {PharmacyError}
                          </div>
                        ) : null}
                  </FormGroup>
                </Col>
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="Wholesaler">Wholesaler</Label>

                    <Input
                      type='select'
                      onChange={(e) => handleWhChange(e)}
                      bsSize='sm'
                      className='required'
                      value={wholesalerID}
                    >
                      <option value={''}>--Select--</option>
                      {wholesalerData.map((status) => {
                        const { id, description } = status;
                        return (
                          <option key={id} value={id}>
                            {description}

                          </option>
                        );
                      })}
                    </Input>
                    {
                      wholesalerError.length > 0
                        ? (
                          <div className="text-danger f-12 position-absolute">
                            {wholesalerError}
                          </div>
                        ) : null}
                  </FormGroup>
                </Col>
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="accountnumber">Account Number</Label>
                    <Input
                      id="accountnumber"
                      name="accountnumber"
                      type='select'
                      onChange={(e) => handleAccountNumberChange(e)}
                      bsSize='sm'
                      className='required'
                      value={SelectedAccountNumber}
                    >
                      <option value={''}>--All--</option>
                      {numberData.map((status) => {
                        const { id, description } = status;
                        return (
                          <option key={id} value={id}>
                            {description}
                          </option>
                        );
                      })}
                    </Input>
                    {
                      accounnumbererror.length > 0
                        ? (
                          <div className="text-danger f-12 position-absolute">
                            {accounnumbererror}
                          </div>
                        ) : null}
                  </FormGroup>
                </Col>
                <Col md={3} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="ndcnumber">Drug Name/NDC</Label>
                    <NDCList
                      onSelect={(value) => handleNdc(value, setFieldValue)}
                      selectedNDC={selectedNdc}
                    >
                    </NDCList>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="d-flex" style={{ justifyContent: "flex-end" }}>
                <Col md="auto" className="">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="search"
                  >
                    <span className="right_5">
                      <img src={searchicon} alt="" />
                    </span>{" "}
                    Search
                  </Button>
                  <Button color="primary"
                    className="reset"
                    onClick={handleReset}
                  >
                    <span className="right_5">
                      <img src={reseticon} alt="" />
                    </span>{" "}
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </div>
  )
}

export default SearchContainer